function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, "\n      .cls-1 {\n        fill: #00ac42;\n      }\n\n      .cls-2 {\n        fill: #215bea;\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-4 {\n        fill: #002a42;\n      }\n    "));

var _ref3 =
/*#__PURE__*/
React.createElement("rect", {
  className: "cls-3",
  x: 0,
  width: 43,
  height: 43,
  rx: 3,
  ry: 3
});

var _ref4 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "cls-4",
  d: "M28.53,9.94v.21c-.12,3.48-1.08,12.13-7.03,17.4-1.35-1.19-2.43-2.56-3.31-4h-5.63c3.08,6.43,7.39,9.07,7.67,9.23l1.27.75,1.27-.75c.42-.25,10.21-6.23,10.72-22.62v-.23s-4.96,0-4.96,0Z"
}), React.createElement("path", {
  className: "cls-2",
  d: "M15.4,16.74h-5.12c.37,1.76.85,3.35,1.41,4.78h5.41c-.76-1.6-1.3-3.24-1.69-4.78Z"
}), React.createElement("path", {
  className: "cls-1",
  d: "M14.47,10.15v-.21h-4.97s0,.23,0,.23c.05,1.62.19,3.13.41,4.56h5.05c-.34-1.86-.46-3.47-.5-4.57Z"
}));

var SvgVeriforceLogo = function SvgVeriforceLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Symbol",
    viewBox: "0 0 43 43",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVeriforceLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Veriforce_Logo.ece78739.svg";
export { ForwardRef as ReactComponent };